import { createFileRoute } from '@tanstack/react-router'

import { WorkflowPage } from '#/modules/ai/back-office/workflow-page/workflow-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/ai/workflows/$workflowId')({
  beforeLoad: ({ context }) => requirePermissions(context, ['systemPrompt.read']),
  component: function Component() {
    const { workflowId } = Route.useParams()
    return <WorkflowPage workflowId={workflowId} />
  },
})
